import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {  } from 'vue';
    import AuthenticationButton from "@/ComponentsChild/AuthenticationButton.vue";
           

export default /*#__PURE__*/_defineComponent({
  __name: 'ParticipantLogin',
  setup(__props) {

    
return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(AuthenticationButton)
  ]))
}
}

})